/* This is Computed based on store */
import * as types from './mutation-types';

export default {
  getCutOffList: state => {
    //
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js